// Imports

import { ConfirmSamplesPopup } from '../../../Rider/Popups';
import {
  SamplesInput,
  OrderConfirmationCheckbox,
  Toast as CustomToast,
} from '../../../../Components';
import React, { useEffect, useState } from 'react';
import { AlertImage } from '../../../../assets/Images';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { loginPageStyles } from '../../../../styles';
import Checkbox from '@mui/material/Checkbox';
import {
  Box,
  Button,
  Divider,
  Table,
  TableBody,
  TableCell,
  tableCellClasses,
  TableHead,
  TableRow,
  styled,
} from '@mui/material';
import { ThemeProvider, createTheme } from '@mui/material/styles';
import { toast } from 'material-react-toastify';
import { destroyUser } from '../../../../redux/features/User';
import PropTypes from 'prop-types';
import {
  setSelectedOrders,
  fetchPracticeOrders,
} from '../../../../redux/features/Practice';
import { useLiveFeed } from '../../../../hooks';

// Table Configuration

const cleanOrders = (data) => {
  let filteredOrders = data.map((item, idx) => {
    return {
      id: idx + 1,
      ...item,
    };
  });
  return filteredOrders;
};

const StyledTableCell = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.head}`]: {
    backgroundColor: '#054E8B',
    color: theme.palette.common.white,
    fontFamily: 'Mukta',
    fontWeight: '700',
    fontSize: '15px',
    lineHeight: '20px',
    padding: '8px 0px 8px 8px',
    borderLeft: '1px solid #054E8B',
  },
}));

const tableCellStyle = {
  fontSize: '15px',
  lineHeight: '19px',
  fontFamily: 'Mulish',
  padding: '8px 0px 8px 8px',
};

export const PickupDetailsScreen = ({
  user,
  enroutedPractice,
  setStep,
  loading,
}) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const practiceOrders = useSelector(
    (state) => state.practicesReducer.practiceOrders
  );

  const enroutedPractices = useSelector(
    (state) => state.practicesReducer.enroutedPractices
  );

  const [orders, setOrders] = useState([]);
  const [confirmation, setConfirmation] = useState(false);
  const [openConfirmPopUp, setOpenConfirmPopUp] = useState(false);
  const [allSelected, setAllSelected] = useState(false);
  const [hasRecieved, setHasRecieved, enroutedPracticeId] = useLiveFeed();
  const handleClickConfirm = () => {
    setOpenConfirmPopUp(true);
  };

  const handleCancel = () => {
    navigate(-1);
  };

  // This Use Effect fetches Orders for a enrouted Practice
  useEffect(() => {
    const data = {
      practiceId: enroutedPractice?.id,
      riderId: user?.id,
      country: user?.country,
    };
    let promise = dispatch(fetchPracticeOrders(data));
    promise.unwrap().catch((err) => {
      if (err?.error === 'You need to sign in or sign up before continuing.') {
        toast(
          <CustomToast
            severity="warning"
            message="Your session has been expired"
          />,
          { closeButton: false }
        );
        dispatch(destroyUser());
        navigate('/login');
      }
    });
  }, []);

  useEffect(() => {
    const riderOrders = [];
    practiceOrders.forEach((data) => {
      riderOrders.push({
        order_id: data.id,
        lab_barcode_id: data.lab_barcode_id,
        type: data.order_type,
        samples: data.order_type === 'manual' ? '' : data.specimens,
        checked: false,
        priority: data.order_priority,
      });
    });
    setOrders(riderOrders);
  }, [loading]);

  // Helper Functions

  const validateOrders = () => {
    return orders.some((order) => order.checked);
  };

  // This function is for selecting all orders
  const handleSelectAll = (event) => {
    let tempOrders = [...orders];
    tempOrders = tempOrders.map((order) => {
      return { ...order, checked: event.target.checked };
    });
    setOrders([...tempOrders]);
    setAllSelected(event.target.checked);
  };

  const classes = loginPageStyles();

  const nextButtonStyle = {
    fontFamily: 'Mukta',
    backgroundColor: '#054E8B',
    textTransform: 'capitalize',
    fontSize: '15px',
    color: '#FFFFFF',
    fontWeight: '700',
    lineHeight: '20px',
  };
  const cancelButtonStyle = {
    fontFamily: 'Mulish',
    textTransform: 'none',
    fontSize: '15px',
    color: '#EA4C59',
    lineHeight: '19px',
    fontWeight: '400',
  };

  const buttonStyle = {
    fontFamily: 'Mukta',
    textTransform: 'none',
    fontSize: '15px',
    color: '#2A3752',
    fontWeight: '700',
    lineHeight: '20px',
    letterSpacing: '0.005em',
  };

  const theme = createTheme({
    components: {
      MuiButton: {
        styleOverrides: {
          root: {
            textTransform: 'none',
            boxShadow: 'none',
            '&.Mui-disabled': {
              opacity: 0.7,
            },
          },
        },
      },
    },
  });

  const handleAddNonEOrderButton = () => {
    setOrders([
      ...orders,
      {
        order_id: '',
        lab_barcode_id: 'Non-eOrder',
        type: 'manual',
        samples: '',
        checked: allSelected ? true : false,
      },
    ]);
  };

  const confirmOrders = () => {
    const checkedOrders = orders.filter(
      (element) => element.checked 
    );
    if (confirmation && checkedOrders.length > 0) {
      dispatch(setSelectedOrders(checkedOrders));
      setStep((prev) => prev + 1);
    }
  };
  // This function handles new Order Alert
  const handleNewOrderAlert = () => {
    toast(
      <CustomToast
        severity="info"
        message={
          enroutedPracticeId === enroutedPractices[0]?.id
            ? 'New Orders Assigned. Tap to view'
            : 'New Orders Assigned'
        }
        handleClick={() =>
          enroutedPracticeId === enroutedPractices[0]?.id &&
          navigate('/collect_order')
        }
      />,
      {
        closeButton: false,
        autoClose:
          enroutedPracticeId === enroutedPractices[0]?.id ? false : true,
      }
    );
    setHasRecieved(false);
  };

  return (
    <React.Fragment>
      <Box
        sx={{
          height: '100%',
          display: 'flex',
          flexDirection: 'column',
        }}
      >
        {hasRecieved && handleNewOrderAlert()}
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            padding: '0 20px',
            mt: '10px',
            mb: '8px',
          }}
        >
          <Box
            className={classes.heading10}
            sx={{
              display: 'flex',
              alignItems: 'center',
              alignContent: 'center',
              textAlign: 'left',
              fontWeight: '700',
              fontSize: '17px',
              lineHeight: '22px',
              color: '#054E8B',
            }}
          >
            {enroutedPractice?.name}
          </Box>
        </Box>
        <Divider />
        <Table size="small" aria-label="customized table">
          <TableHead>
            <TableRow>
              <StyledTableCell>Sr. No.</StyledTableCell>
              <StyledTableCell style={{ paddingLeft: 0 }}>
                Order ID
              </StyledTableCell>
              <StyledTableCell>No. of Samples</StyledTableCell>
              <StyledTableCell style={{ paddingLeft: '16px' }}>
                <Checkbox
                  sx={{
                    color: '#fff',
                    '&.Mui-checked': {
                      color: '#fff',
                    },
                    '&.MuiButtonBase-root': {
                      padding: '0px',
                      verticalAlign: 'middle',
                    },
                  }}
                  checked={allSelected}
                  onClick={handleSelectAll}
                />
              </StyledTableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {cleanOrders(orders).map((row, index) => (
              <TableRow key={row.id}>
                <TableCell sx={tableCellStyle} style={{ width: '17%' }}>
                  {row.id}.
                </TableCell>
                <TableCell
                  sx={tableCellStyle}
                  style={{ paddingLeft: 0, width: '32%' }}
                >
                  <Box
                    sx={{
                      display: 'flex',
                      alignItems: 'center',
                      lineBreak: 'anywhere',
                    }}
                  >
                    {row.lab_barcode_id}
                    {row?.priority === 'urgent' && (
                      <img src={AlertImage} alt="" />
                    )}
                  </Box>
                </TableCell>
                <TableCell
                  align="left"
                  sx={{
                    p: row.type === 'manual' ? '2px 0px' : '11px 0px',
                  }}
                >
                  <Box
                    sx={{
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'space-between',
                      marginLeft: '0.5rem',
                      width: '90%',
                    }}
                  >
                    <SamplesInput
                      index={index}
                      value={row?.samples}
                      orders={orders}
                      setOrders={setOrders}
                    />
                  </Box>
                </TableCell>
                <TableCell>
                  <OrderConfirmationCheckbox
                    index={index}
                    value={row?.checked}
                    orders={orders}
                    setOrders={setOrders}
                    setAllSelected={setAllSelected}
                  />
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
        <Box sx={{ flex: 1 }}>
          {' '}
          <Box
            sx={{
              display: 'flex',
              justifyContent: 'center',
            }}
          >
            <Button
              onClick={handleAddNonEOrderButton}
              variant="text"
              sx={{
                border: 1,
                borderColor: '#E5E5E5',
                marginTop: '12px',
                marginBottom: '16px',
                height: '36px',
                p: '4px 20px',
                width: 'auto',
                borderRadius: '8px',
              }}
              style={buttonStyle}
            >
              Add Non-eOrder
            </Button>
          </Box>
          <Box
            sx={{
              display: 'flex',
              justifyContent: 'center',
            }}
          >
            <Box
              sx={{
                maxWidth: '320px',
                width: '100%',
                marginTop: '20px',
                marginBottom: '120px',
                display: 'flex',
                flexDirection: 'row',
                justifyContent: 'center',
              }}
            >
              <OrderConfirmationCheckbox
                value={confirmation}
                setConfirmation={setConfirmation}
              />
              <Box
                className={classes.heading}
                sx={{
                  ml: '2px',
                  display: 'flex',
                  justifyContent: 'center',
                  alignItems: 'center',
                  fontSize: '13px',
                  color: '#111111',
                  lineHeight: '19px',
                }}
              >
                I ensure that the orders and samples quantity listed are
                correct.
              </Box>
            </Box>
          </Box>
          <Box
            sx={{
              width: '100%',
            }}
          >
            <Box
              sx={{
                display: 'flex',
                justifyContent: 'center',
                mb: '32px',
              }}
            >
              <Box
                sx={{
                  maxWidth: '280px',
                  width: '100%',
                  display: 'flex',
                  justifyContent: 'space-between',
                  mb: '43px',
                  pl: '10px',
                  pr: '8px',
                }}
              >
                <Button
                  onClick={handleCancel}
                  variant="text"
                  sx={{
                    border: 1,
                    borderColor: '#E5E5E5',
                    maxWidth: '86px',
                    width: '100%',
                    borderRadius: '10px',
                    py: '4px',
                  }}
                  style={cancelButtonStyle}
                >
                  Cancel
                </Button>
                <ThemeProvider theme={theme}>
                  <Button
                    onClick={handleClickConfirm}
                    disabled={!(confirmation && validateOrders())}
                    variant="text"
                    sx={{
                      maxWidth: '86px',
                      width: '100%',
                      borderRadius: '8px',
                      ':hover': { bgcolor: '#054E8B' },
                    }}
                    style={nextButtonStyle}
                  >
                    Next
                  </Button>
                </ThemeProvider>
              </Box>
            </Box>
            {openConfirmPopUp && (
              <ConfirmSamplesPopup
                confirmEOrders={confirmOrders}
                openConfirmPopUp={openConfirmPopUp}
                setOpenConfirmPopUp={setOpenConfirmPopUp}
              />
            )}
          </Box>
        </Box>
      </Box>
    </React.Fragment>
  );
};
PickupDetailsScreen.propTypes = {
  user: PropTypes.object.isRequired,
  enroutedPractice: PropTypes.object.isRequired,
  setStep: PropTypes.func.isRequired,
  loading: PropTypes.bool.isRequired,
};
export default PickupDetailsScreen;
